export default __webpack_public_path__ + "images/e2290f36736414bf5fbb949fe1df7e0d.png";